import { create } from "zustand";
import { IChase } from "../types/chase-type";

interface IdefaultValues {
  id: number;
  chase: IChase;
}

const defaultValues = {
  id: null,
  chase: null,
};

interface IuseChaseMenu {
  onChaseMenuOpen: ({ id }: IdefaultValues) => void;
  onChaseMenuClose: () => void;
  onToggleChaseMenu: ({ id }: IdefaultValues) => void;
  initialValues: IdefaultValues;
}

export const useChaseMenu = create<IuseChaseMenu>((set) => ({
  initialValues: defaultValues,
  onChaseMenuOpen: ({ id, chase }: IdefaultValues) =>
    set({
      initialValues: { id, chase },
    }),
  onChaseMenuClose: () =>
    set({
      initialValues: defaultValues,
    }),
  onToggleChaseMenu: ({ id, chase }: IdefaultValues) =>
    set((prevState) => ({
      initialValues:
        prevState.initialValues.id === id ? defaultValues : { id, chase },
    })),
}));
